module.exports = __webpack_public_path__ + "img/completed.1309acd1.png";